import { staticContent } from '@src/routes'
import { DocumentLink } from '@src/types/graphql-types'
import messages from '@src/utils/messages'

export const tiers = {
  tier1: {
    CERTIFICATE: messages.CERTIFICATES,
    DATA_SHEET: messages.DATA_SHEETS,
    PACK_INSERT_MANUAL: messages.INSTRUCTIONS_FOR_USE,
    USER_GUIDE: messages.USER_GUIDE,
    PRODUCT_INFORMATION_SHEET: messages.PRODUCT_INFORMATION_SHEET,
  },
  tier2: {
    BROCHURE: messages.BROCHURES,
    PROTOCOL: messages.PROTOCOL,
    APPLICATION_NOTE: messages.APPLICATION_NOTES,
    REQUIRED_LICENSES: messages.REQUIRED_LICENSES,
    TECHNICAL_INFORMATION: messages.TECHNICAL_INFORMATION,
    WHITE_PAPER: messages.WHITE_PAPER,
    INSTRUCTIONS: messages.PROTOCOL,
    TECH_NOTES: messages.TECHNICAL_INFORMATION,
  },
  tier3: {
    NEWSLETTER_PUBLICATION: messages.NEWSLETTER_PUBLICATION,
    POSTER: messages.POSTER,
    VECTOR: messages.VECTOR,
    CASE_STUDY: messages.CASE_STUDY,
    DEMO_DOSSIER: messages.DEMO_DOSSIER,
    FLYER: messages.FLYER,
    FLYER_AD: messages.FLYER,
    FORMULATION: messages.FORMULATION,
  },
}
const { tier1, tier2, tier3 } = tiers

const determineTier = (tier, tierLinks, link) => {
  if (!!tier[link.key] && !!tierLinks[link.key]) {
    tierLinks[link.key].push(link)
  } else {
    tierLinks[link.key] = [link]
  }
}

export const setupTiers = (links, country, language, intl) => {
  const bulkQuoteHref = staticContent.index({
    path: '/services/support/bulk-quotation-request',
    country,
    language,
  }).as

  const tier1Links = {}
  const tier2Links = {}
  const tier3Links = {}

  const quoteOrderLink = [
    {
      anchorTag: `<a href="${bulkQuoteHref}">${intl.formatMessage(
        messages.BULK_QUOTE
      )}</a>`,

      image: '',
      key: 'QUOTES_AND_ORDERING',
      label: intl.formatMessage(messages.BULK_QUOTE),
    },
  ]

  const remainingLinks: DocumentLink[] = []

  links.forEach((link) => {
    !link.key
      ? remainingLinks.push(link)
      : !!tier1[link.key]
        ? determineTier(tier1, tier1Links, link)
        : !!tier2[link.key]
          ? determineTier(tier2, tier2Links, link)
          : !!tier3[link.key]
            ? determineTier(tier3, tier3Links, link)
            : remainingLinks.push(link)
  })

  const moreLinks = remainingLinks.sort((a, b) => {
    return a.label < b.label ? -1 : 1
  })
  return { tier1Links, tier2Links, tier3Links, moreLinks, quoteOrderLink }
}
